import { React, useMemo, useState } from "react";
import { useQuery } from "react-query";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import axios from "axios";
import { Box, CircularProgress, TextField, MenuItem } from "@mui/material";
import SideBar from "../sideBar/SideBar";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const ButtonStyle = styled.button`
  margin-top: 7px;
  width: 250px;
  height: 55px;
  background-color: #c7131c;
  color: #fff;
  font-weight: bold;
  font-size: 18px;
  border-color: #c7131c;
  border-radius: 5px;
  cursor: pointer;
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
const ErrorText = styled.p`
  color: red;
  margin: 4px 0 0;
`;

export default function Transactions() {
  // تاريخ اليوم بصيغة YYYY-MM-DD
  const todayStr = useMemo(() => {
    const d = new Date();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${d.getFullYear()}-${mm}-${dd}`;
  }, []);
  const nowTimeStr = useMemo(() => {
    const d = new Date();
    const hh = String(d.getHours()).padStart(2, "0");
    const mm = String(d.getMinutes()).padStart(2, "0");
    return `${hh}:${mm}`; // شكل HH:MM
  }, []);
  // ✅ سكيمة بسيطة: التاريخ + المندوب إلزاميَّين
  // مبنلزمش أي خانة من التلاتة، لكن هنتأكد قبل الإرسال إن فيه واحدة على الأقل > 0
  const numberOrZero = yup
    .number()
    .transform((v, orig) => (orig === "" || orig == null ? 0 : v))
    .typeError("القيمة يجب أن تكون رقمًا")
    .min(0, "يجب أن تكون القيمة 0 أو أكبر")
    .nullable();

  const schema = yup.object().shape({
    dayDate: yup.string().required("التاريخ مطلوب"),
    transTime: yup.string().required("الوقت مطلوب"),
    runnerID: yup
      .number()
      .typeError("اختيار المندوب مطلوب")
      .required("اختيار المندوب مطلوب"),
    loanAmount: numberOrZero,
    penaltyAmount: numberOrZero,
    rewardAmount: numberOrZero,
    notes: yup.string().nullable(),
  });

  const [isLoading, setIsLoading] = useState(false);

  const {
    handleSubmit,
    register,
    reset,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onTouched",
    defaultValues: {
      dayDate: todayStr,
      transTime: nowTimeStr,
      runnerID: undefined,
      loanAmount: "",
      penaltyAmount: "",
      rewardAmount: "",
      notes: "",
    },
  });

  const navigate = useNavigate();

  const accessToken = localStorage.getItem("userStorage")
    ? JSON.parse(localStorage.getItem("userStorage")).accessToken
    : null;

  const { data: runnerData } = useQuery(
    "runner_list",
    async () => {
      const data = await axios.post(
        "https://anydev.com-eg.net/api/RunnersActivity/V1/GetRunnersListEX/0",
        { pageSize: 10000, pageNumber: 1 },
        {
          headers: {
            CompanyID: "241701",
            AccessToken: `${accessToken}`,
          },
        }
      );
      return data.data.data;
    },
    {
      onError: (error) => {
        if (error.response && error.response.status === 401) {
          localStorage.clear();
          navigate("/");
        }
      },
    }
  );

  const [selectedRunnerId, setSelectedRunnerId] = useState("");
  const [selectedRunnerCode, setSelectedRunnerCode] = useState("");

  const handleRunnerNameChange = (e) => {
    const runnerId = e.target.value;
    setSelectedRunnerId(runnerId);
    setValue("runnerID", +runnerId);

    if (runnerId === "0" || runnerId === "") {
      setSelectedRunnerCode("");
      return;
    }
    const selectedRunner = runnerData?.find((r) => r.id === +runnerId);
    setSelectedRunnerCode(selectedRunner?.code || "");
  };

  const handleRunnerCodeChange = (e) => {
    const runnerCode = e.target.value;
    setSelectedRunnerCode(runnerCode);

    if (runnerCode === "0" || runnerCode === "") {
      setSelectedRunnerId("");
      setValue("runnerID", undefined);
      return;
    }
    const selectedRunner = runnerData?.find((r) => r.code === runnerCode);
    setSelectedRunnerId(selectedRunner?.id || "");
    setValue("runnerID", selectedRunner?.id || undefined);
  };

  async function submitHandler(data) {
    // ✅ تأكيد أن على الأقل فيه خانة واحدة > 0
    const loan = Number(data.loanAmount) || 0;
    const penalty = Number(data.penaltyAmount) || 0;
    const reward = Number(data.rewardAmount) || 0;
    if (loan <= 0 && penalty <= 0 && reward <= 0) {
      alert("من فضلك أدخل سلفة أو جزاء أو مكافأة (واحدة على الأقل).");
      return;
    }

    try {
      setIsLoading(true);

      // ✅ البايلود: نبعت الثلاث خانات مع التاريخ
      const payload = {
        runnerID: data.runnerID,
        loan,
        reward,
        penalty,
        notes: data.notes || "",
        transDate: `${data.dayDate}T${data.transTime}:00`, // لو الـ API عايز اسم تاني للتاريخ عدِّله هنا (مثلاً dayDate)
      };

      await axios.post(
        "https://anydev.com-eg.net/api/RunnersActivity/V1/SaveRunnerDairy",
        payload,
        {
          headers: {
            CompanyID: "241701",
            AccessToken: `${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      alert("تم حفظ العملية/العمليات بنجاح.");

      // ✅ تفريغ النموذج بالكامل وإرجاع التاريخ لليوم
      reset({
        dayDate: todayStr,
        transTime: nowTimeStr,
        runnerID: undefined,
        loanAmount: "",
        penaltyAmount: "",
        rewardAmount: "",
        notes: "",
      });
      setSelectedRunnerId("");
      setSelectedRunnerCode("");
    } catch (err) {
      console.error(err);
      if (err.response && err.response.status === 401) {
        localStorage.clear();
        navigate("/");
      } else {
        alert("حدث خطأ أثناء الحفظ. حاول مرة أخرى.");
      }
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="control-pane">
      <SideBar />
      <form onSubmit={handleSubmit(submitHandler)}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            gap: "25px",
            marginRight: "20px",
            flexWrap: "wrap",
            direction: "rtl",
          }}
        >
          {/* التاريخ */}
          <Box sx={{ marginTop: "7px" }}>
            <TextField
              label="التاريخ"
              type="date"
              InputLabelProps={{ shrink: true }}
              sx={{ width: "220px" }}
              {...register("dayDate")}
            />
            <ErrorText>{errors.dayDate?.message}</ErrorText>
          </Box>
          <Box sx={{ marginTop: "7px" }}>
            <TextField
              label="الوقت"
              type="time"
              InputLabelProps={{ shrink: true }}
              sx={{ width: "160px" }}
              {...register("transTime")}
            />
            <ErrorText>{errors.transTime?.message}</ErrorText>
          </Box>
          {/* المندوب بالاسم */}
          <Box sx={{ marginTop: "7px" }}>
            <TextField
              select
              label="اختَر المندوب بالاسم"
              sx={{ width: "250px" }}
              value={selectedRunnerId}
              onChange={handleRunnerNameChange}
            >
              {runnerData?.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.arabicName}
                </MenuItem>
              ))}
            </TextField>
            <ErrorText>{errors.runnerID?.message}</ErrorText>
          </Box>

          {/* المندوب بالكود */}
          <Box sx={{ marginTop: "7px" }}>
            <TextField
              select
              label="اختَر المندوب بالكود"
              sx={{ width: "250px" }}
              value={selectedRunnerCode}
              onChange={handleRunnerCodeChange}
            >
              {runnerData?.map((item) => (
                <MenuItem key={item.code} value={item.code}>
                  {item.code}
                </MenuItem>
              ))}
            </TextField>
          </Box>

          {/* سلفة */}
          <Box sx={{ marginTop: "7px" }}>
            <TextField
              label="سلفة (loan)"
              type="number"
              inputProps={{ min: 0, step: "1" }}
              sx={{ width: "200px" }}
              {...register("loanAmount")}
            />
            <ErrorText>{errors.loanAmount?.message}</ErrorText>
          </Box>

          {/* جزاء */}
          <Box sx={{ marginTop: "7px" }}>
            <TextField
              label="جزاء (penalty)"
              type="number"
              inputProps={{ min: 0, step: "1" }}
              sx={{ width: "200px" }}
              {...register("penaltyAmount")}
            />
            <ErrorText>{errors.penaltyAmount?.message}</ErrorText>
          </Box>

          {/* مكافأة */}
          <Box sx={{ marginTop: "7px" }}>
            <TextField
              label="مكافأة (reward)"
              type="number"
              inputProps={{ min: 0, step: "1" }}
              sx={{ width: "200px" }}
              {...register("rewardAmount")}
            />
            <ErrorText>{errors.rewardAmount?.message}</ErrorText>
          </Box>

          {/* الملاحظات */}
          <Box sx={{ marginTop: "7px" }}>
            <TextField
              label="ملاحظات"
              multiline
              sx={{ width: "320px" }}
              {...register("notes")}
            />
          </Box>

          {/* الزر */}
          <ButtonStyle type="submit" disabled={isLoading || isSubmitting}>
            {isLoading || isSubmitting ? <CircularProgress size={22} /> : `حفظ`}
          </ButtonStyle>
        </Box>
      </form>
    </div>
  );
}
